import React, { Component } from 'react';
import { Table, ButtonToolbar, Button, Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Label, Modal } from 'react-bootstrap';

import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { TableButton } from '../../../TableButton';

export class VerticalDayTimesheetDataIdentifier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: this.props.selectedData,
            table: {
                data: [],
                loading: true,
                page: 1,
                elementsPerPage: 10
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            },
            form: {
                show: false,
                id: 0,
                descriptionPt: "",
                descriptionEn: ""
            },
            actions: {
                isLoading: true
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                table: {
                    data: [],
                    loading: true,
                    page: 1,
                    elementsPerPage: 10
                },
                actions: actions
            });
        }

        const setOfDayTypesCommand = new SetOfDayTypesCommand();
        setOfDayTypesCommand.list(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    errorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    // -----------------------

    onSelectData(data) {
        const { selectedData } = this.state;
        const dataStrId = `${data.id}`;

        let splitedData = [];
        if (null !== selectedData && undefined !== selectedData) {
            splitedData = selectedData.split("|%|");
        }

        let descriptionPt = "";
        let descriptionEn = "";
        if (dataStrId === splitedData[0]) {
            if (undefined !== splitedData[1]) {
                const jsonObject = JSON.parse(splitedData[1]);

                descriptionPt = jsonObject.descriptionPt;
                descriptionEn = jsonObject.descriptionEn;
            }
        }

        this.setState({
            form: {
                show: true,
                id: dataStrId,
                descriptionPt: descriptionPt,
                descriptionEn: descriptionEn
            }
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        if ("" === e.target.validationMessage) {
            form[target] = e.target.value;
        }

        this.setState({
            form: form
        });
    }

    onFinishSelectData() {
        const { form } = this.state;

        const jsonObject = {
            descriptionPt: form.descriptionPt,
            descriptionEn: form.descriptionEn,
        };
        const data = `${form.id}|%|${JSON.stringify(jsonObject)}`;

        this.props.onSelectData(data);

        this.setState({
            selectedData: data,
            form: {
                show: false,
                id: 0,
                descriptionPt: "",
                descriptionEn: ""
            }
        });
    }

    onCancelSelectData() {
        this.setState({
            form: {
                show: false,
                id: 0,
                descriptionPt: "",
                descriptionEn: ""
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    renderSelectedDataDescriptionPt(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        const splitedData = `${selectedData}`.split("|%|");

        if (`${obj.id}` === splitedData[0] && undefined !== splitedData[1]) {
            return (
                <div>{JSON.parse(splitedData[1]).descriptionPt}</div>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSelectedDataDescriptionEn(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        const splitedData = `${selectedData}`.split("|%|");

        if (`${obj.id}` === splitedData[0] && undefined !== splitedData[1]) {
            return (
                <div>{JSON.parse(splitedData[1]).descriptionEn}</div>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSelectedDataLabel(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        if (`${obj.id}` === selectedData.split("|%|")[0]) {
            return (
                <h5><Label bsStyle="success" className="icon-ok icon-img">&nbsp;</Label></h5>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSelectedDataButton(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <TableButton icon="icon-select" title="Selecionar" onClick={() => this.onSelectData(obj)} />
            );
        }

        if (`${obj.id}` === selectedData.split("|%|")[0]) {
            return (
                <TableButton icon="icon-edit" title="Editar" onClick={() => this.onSelectData(obj)} />
            );
        }
        else {
            return (
                <TableButton icon="icon-select" title="Selecionar" onClick={() => this.onSelectData(obj)} />
            );
        }
    }

    render() {
        const { isLoading } = this.state.actions;

        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        const { table, form, message } = this.state;
        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Table responsive striped hover style={{ marginTop: 10 }}>
                                <thead>
                                    <tr>
                                        <th>Valor</th>
                                        <th>Descrição PT</th>
                                        <th>Descrição EN</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((obj, idx) =>
                                            <tr key={`data-${idx}`}>
                                                <td>{obj.name}</td>
                                                <td>{this.renderSelectedDataDescriptionPt(obj)}</td>
                                                <td>{this.renderSelectedDataDescriptionEn(obj)}</td>
                                                <td>{this.renderSelectedDataLabel(obj)}</td>
                                                <td>{this.renderSelectedDataButton(obj)}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={table.data.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                        </Col>
                    </Row>
                </Grid>

                <Modal show={form.show}>
                    <Modal.Body>
                        <Form>
                            <FormGroup controlId="formDescriptionPtText">
                                <ControlLabel>Descrição PT</ControlLabel>
                                <FormControl
                                    type="text"
                                    placeholder="Descrição PT"
                                    value={form.descriptionPt}
                                    onChange={(e) => this.onChangeValue(e, 'descriptionPt')}
                                />
                            </FormGroup>
                            <FormGroup controlId="formDescriptionEnText">
                                <ControlLabel>Descrição EN</ControlLabel>
                                <FormControl
                                    type="text"
                                    placeholder="Descrição EN"
                                    value={form.descriptionEn}
                                    onChange={(e) => this.onChangeValue(e, 'descriptionEn')}
                                />
                            </FormGroup>
                        </Form>

                        <ButtonToolbar>
                            <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>GUARDAR</Button>
                            <Button bsStyle="default" onClick={() => this.onCancelSelectData()}>CANCELAR</Button>
                        </ButtonToolbar>
                    </Modal.Body>
                </Modal>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/VerticalDayTimesheetDataIdentifier.js